import { render, staticRenderFns } from "./general-edit-tab.vue?vue&type=template&id=48fccdd6&scoped=true"
import script from "./general-edit-tab.vue?vue&type=script&lang=js"
export * from "./general-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./general-edit-tab.vue?vue&type=style&index=0&id=48fccdd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fccdd6",
  null
  
)

export default component.exports